import { CommonModule, NgClass } from '@angular/common'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core'
import { ValidatorFn } from '@angular/forms'

import { CaseInput } from '../../../interfaces/case-input.interface'
import { SelectOption } from '../../../interfaces/select-option.interface'
import { HtmlTooltipDirective } from '../../../standalone-exports'

@Component({
    selector: 'case-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.scss'],
    standalone: true,
    imports: [CommonModule, HtmlTooltipDirective, NgClass]
})
export class SelectInputComponent implements CaseInput, OnChanges {
  @Input() label: string
  @Input() placeholder: string
  @Input() helpText: string
  @Input() initialValue: string | number | boolean
  @Input() selectOptions: SelectOption[]
  @Input() readonly: boolean
  @Input() showErrors = false
  @Input() validators: ValidatorFn[] = []
  @Input() uniqueId: string
  @Input() required: boolean
  @Input() htmlTooltip: string

  @Output() valueChanged: EventEmitter<string> = new EventEmitter()
  @ViewChild('select', { static: true }) select: ElementRef

  value: string = null
  isInvalid: boolean = false

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.selectOptions &&
      !changes.selectOptions.firstChange &&
      !changes.selectOptions.currentValue
        .map((o) => o.value)
        .includes(this.value)
    ) {
      this.valueChanged.emit(null)
    } else {
      if (this.initialValue != null) {
        setTimeout(() => {
          this.select.nativeElement.value = this.initialValue
          this.value = String(this.initialValue)
          this.validateField()
        }, 0)
      }
    }

    if (changes.showErrors) {
      this.validateField()
    }
  }

  onSelect(newValue: string) {
    this.value = newValue
    this.validateField()
    this.valueChanged.emit(this.value)
  }

  private validateField() {
    this.isInvalid = this.showErrors && this.required && !this.value
  }
}
